import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=35a79c62&scoped=true&"
import script from "./Sidebar.vue?vue&type=script&lang=js&"
export * from "./Sidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a79c62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('35a79c62', component.options)
    } else {
      api.reload('35a79c62', component.options)
    }
    module.hot.accept("./Sidebar.vue?vue&type=template&id=35a79c62&scoped=true&", function () {
      api.rerender('35a79c62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/partials/Sidebar.vue"
export default component.exports